import { Icon } from "@iconify/react";

type FooterProps = {
  scrollToTop: () => void;
};
export function Footer({ scrollToTop }: FooterProps): JSX.Element {
  return (
    <footer className="footer">
      <button className="footer-back-btn" onClick={scrollToTop}>
        Back to Top
      </button>
      <div className="footer-icons-container">
        <button className="footer-icon">
          <Icon
            icon="ant-design:linkedin-outlined"
            height="2rem"
            width="2rem"
          />
        </button>

        <button className="footer-icon">
          <Icon icon="eva:email-outline" height="2rem" width="2rem" />
        </button>
      </div>
      <p className="footer-copyright"> &#169;2021 Guilherme Puszkarek</p>
    </footer>
  );
}
